import axios from 'axios';
import firebase from 'firebase/app';

// ----------------------------------------------------------------------

const axiosInstance = axios.create();

// Add a request interceptor to attach the Firebase token
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const auth = firebase.auth(); // Get Firebase Auth instance
      const user = auth.currentUser;
      if (user) {
        const idToken = await user.getIdToken(true);
        config.headers.id_token = `Bearer ${idToken}`;
      }
    } catch (error) {
      console.error('Error fetching Firebase ID token:', error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
